import React from "react";
import { useFormContext } from "react-hook-form";


const RadioButtonV2 = ({
  id,
  value,
  name,
  className,
  labelName,
  htmlFor,
  onClick,
  labelClassName,
  validation,
  checked,
  dataQuestId,
  dataAnsId,
  dataAnsLabel,
  iclassName,
}) => {
  const { register, errors } = useFormContext();

  return (
    <>
    
      <input
        type="radio"
        className="d-none card2 p-lg-2 p-md-2 p-sm-4 p-3 align-items-center"
        name={name}
        id={id}
        value={value}
        ref={register({required: "Please select card type" })}
        checked={checked}
      />
      <label htmlFor={htmlFor} className={className} onClick={(e) => onClick(e,id,value)}>

        <div>
          <i className={iclassName} />
        </div>
        <div className={labelClassName}>
        {labelName}
        </div>
      </label>
      
    </>
  );
};
export default RadioButtonV2;
